import { Badge, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";

const NavItem = ({ iconId, text, link, submenuItems, icon, unreadCount = 0, disabled = false, disabledTooltip = '' }) => {
    if (disabled) {
        return (
            <li className="pc-item hive-base-side-menu-item">
                <Tooltip title={disabledTooltip} placement="right" describeChild>
                    <span className="pc-link hive-base-side-menu-link" role="link" aria-disabled="true" tabIndex={0}
                        style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                        <span className="side-nav-icon hive-base-side-menu-icon">{icon}</span>
                        <span className="pc-mtext hive-base-side-menu-text">{text}</span>
                    </span>
                </Tooltip>
            </li>
        );
    }
    const showBadge = text === "Chat" && unreadCount > 0;
    return (
        <li className={`pc-item hive-base-side-menu-item ${submenuItems ? "pc-hasmenu" : ""}`}>
            <Link to={link || "/"} className="pc-link hive-base-side-menu-link">
                <span className="side-nav-icon hive-base-side-menu-icon">
                    {icon}
                </span>

                <span className="pc-mtext hive-base-side-menu-text">
                {showBadge ? (
                    <Badge
                    badgeContent={unreadCount}
                    color="error"
                    overlap="rectangular"
                    sx={{
                        "& .MuiBadge-badge": {
                        right: -12,
                        top: 6,
                        },
                    }}
                    >
                    {text}
                    </Badge>
                ) : (
                    text
                )}
                </span>

            {submenuItems && (
            <span className="pc-arrow hive-base-side-menu-arrow">
                <i data-feather="chevron-right"></i>
            </span>
            )}
        </Link>

        {submenuItems && (
            <ul className="pc-submenu hive-base-side-submenu">
            {submenuItems.map((submenuItem, index) => (
                <li key={index} className="pc-item hive-base-side-menu-item hive-base-side-submenu-item">
                <Link className="pc-link hive-base-side-menu-link hive-base-side-submenu-link" to={submenuItem.link}>
                    {submenuItem.text}
                </Link>
                </li>
            ))}
            </ul>
        )}
        </li>
    );
};

export default NavItem
